const Configuracion = 
  {
    proyecto: "afirmeinfonavit",
    version: "1.2.1",
    applicacion: "AFIRME INFONAVIT",
    derechos:"POWER BY © SINESTRY 2025",
    basedatos:"siniestrosapdb",
    mensajesplash:"",
    author:"Ing.Juan Carlos Arreola Lopez",
    urlapi://"http://localhost:4001",
            'https://sinestrydev-552789706120.us-central1.run.app', 
  };
export default Configuracion;
